import React, { useState, useEffect, useContext, useRef } from 'react'
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { POInnerStyle, POFormStyle, POItemListStyle } from './css/POInnerStyle'
import { ContentInner } from '../../../layout/Content'
import AutoCompleteList from '../../../layout/AutoCompleteList'
import { filterItemsSearch } from '../../../utilities/utilities'
import { poControllerContext } from './POController'

function POForm() {
  const poController = useContext(poControllerContext)
  const [po, setPO] = poController.po
  const { poList } = poController
  const [activeInput, setActiveInput] = useState('')
  const [keyPressed, setKeyPressed] = useState('')
  const [itemClicked, setItemClicked] = useState(false)
  const [currentPOList, setCurrentPOList] = useState([])

  const onChange = (e) => {
    const itemName = ['supplier', 'prepared_by', 'remarks']

    // Avoid unwanted character
    if (!keyPressed) return

    setPO({ ...po, [e.target.name]: e.target.value })

    // If the item is not on the array then return
    if (!itemName.find(item => item === e.target.name)) return

    setActiveInput(e.target.name)
    const filteredItemList = filterItemsSearch(poList.map(item => item[e.target.name]), e.target.value)
    setCurrentPOList(filteredItemList)
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break;
      case 'Enter':
      case 'Tab':
      case 'Escape':
        if (e.target.name !== 'reference_code') {
          setCurrentPOList([])
          ReactDOM.unmountComponentAtNode(document.getElementById(e.target.name+'-acl-container'))
        }
        break
      default:
        setKeyPressed(e.key)
    }
  }

  const onFocusAccessMode = () => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }

  useEffect(() => {
    if (activeInput) {
      if (currentPOList.length > 0)
        ReactDOM.render(
          <AutoCompleteList
            valueSetter={(value) => setPO({ ...po, [activeInput]: value })}
            keyPressed={keyPressed}
            setItemClicked={setItemClicked}
            items={currentPOList}
          />, document.getElementById(activeInput+'-acl-container')
        )
      else
        ReactDOM.unmountComponentAtNode(document.getElementById(activeInput+'-acl-container'))
    }

    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')

    if (itemClicked) {
      setItemClicked(false)
      setCurrentPOList([])
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [po.supplier, po.prepared_by, po.remarks, keyPressed, itemClicked])

  return (
    <React.Fragment>
      <div id='po-form-container'>
        <div id='add-new-po-header'>New Purchase Order</div>
        <hr />
        <div className='po-form' id='date-prepared-container'>
          <label htmlFor='date-prepared'>Date Prepared*</label>
          <div className='input-container'>
            <input
              type='date'
              id='date-prepared'
              name='date_prepared'
              placeholder='date prepared'
              value={po.date_prepared}
              onChange={(e) => setPO({ ...po, date_prepared: e.target.value})} />
          </div>
        </div>
        <div className='po-form' id='prepared-by-container'>
          <label htmlFor='prepared-by'>Prepared By*</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='prepared_by'
              name='prepared_by'
              placeholder='prepared by'
              value={po.prepared_by}
              onKeyDown={onKeyDown}
              onChange={onChange}/>
            <div id='prepared_by-acl-container' className='acl-container'></div>
          </div>
        </div>
        <div className='po-form' id='supplier-container'>
          <label htmlFor='supplier'>Supplier</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='supplier'
              name='supplier'
              placeholder='supplier'
              value={po.supplier}
              onKeyDown={onKeyDown}
              onChange={onChange}/>
            <div id='supplier-acl-container' className='acl-container'></div>
          </div>
        </div>
        <div className='po-form' id='reference-code-container'>
          <label htmlFor='reference-code'>Reference</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='reference_code'
              name='reference_code'
              placeholder='reference code'
              onKeyDown={onKeyDown}
              value={po.reference_code}
              onChange={onChange}/>
          </div>
        </div>
        <div className='po-form' id='remarks-container'>
          <label htmlFor='remarks'>Remarks</label>
          <div className='input-container'>
            <input
              autoComplete='off'
              id='remarks'
              name='remarks'
              placeholder='remarks'
              value={po.remarks}
              onKeyDown={onKeyDown}
              onChange={onChange}/>
            <div id='remarks-acl-container' className='acl-container'></div>
          </div>
        </div>
        <div className='po-form' id='access-mode-container'>
          <div className='input-checkbox-container'>
            <input
              type='checkbox'
              id='access_mode'
              name='access_mode'
              value={po.access_mode}
              checked={po.access_mode}
              onFocus={onFocusAccessMode}
              onChange={() => setPO({ ...po, access_mode: (po.access_mode === 1) ? 0 : 1 })}/>
              <label htmlFor='access_mode'>Delete this P.O. record after received.</label>
          </div>
        </div>
      </div>
      <POFormStyle />
    </React.Fragment>
  )
}

function POItemList() {
  const poItemDetailNameRef = useRef(null)
  const poController = useContext(poControllerContext)
  const [po, setPO] = poController.po
  const [poItemDetail, setPOItemDetail, resetPOItemDetail] = poController.poItemDetail
  const { productsList } = poController
  const [itemUnitDescriptionList, setItemUnitDescriptionList] = useState([])
  const [currentProductsList, setCurrentProductsList] = useState([])
  const [keyPressed, setKeyPressed] = useState('')
  const [itemClicked, setItemClicked] = useState(false)
  const [currentItemIndex, setCurrentItemIndex] = useState(null)
  const [currentItem, setCurrentItem] = useState(null)
  const [editMode, setEditMode] = useState(null)

  const [itemOK, setItemOK] = useState(false)
  const [currentUnitIsFractional, setCurrentUnitIsFractional] = useState(null)

  const onChange = (e) => {
    // Avoid unwanted characters to prevent regular expressions error on filter
    if (!keyPressed) return

    setPOItemDetail({ ...poItemDetail, name: e.target.value })
    const filteredItemList = filterItemsSearch(productsList.map(product => product.item_full_description), e.target.value)
    setCurrentProductsList(filteredItemList)
  }

  const onKeyDown = (e) => {
    switch(e.key) {
      case '\\':
      case '*':
      case '+':
      case '[':
      case '(':
      case '?':
      case '$':
        setKeyPressed(false)
        break;
      case 'Enter':
      case 'Tab':
      case 'Escape':
        setCurrentProductsList([])
        ReactDOM.unmountComponentAtNode(document.getElementById('name-acl-container'))
        break
      default:
        setKeyPressed(e.key)
    }
  }

  const highlightItemDetailsRow = (itemIndex, highlight=false) => {
    const itemDetailsRow = document.getElementById(itemIndex+'item-details-row')
    if (highlight) itemDetailsRow.classList.add('highlight-item-details-row')
    else itemDetailsRow.classList.remove('highlight-item-details-row')
  }

  const onClickPOAddItem = async (e) => {
    if (currentItemIndex !== null) { // It's on edit mode

      po.item_details[currentItemIndex] = poItemDetail

      setCurrentItemIndex(null)
      highlightItemDetailsRow(currentItemIndex, false)
    } else {
      setPO({ ...po, item_details: [...po.item_details, poItemDetail] })
    }

    // Resets
    resetPOItemDetail()
    setCurrentItem(null)

    await poItemDetailNameRef.current.focus()
    await poItemDetailNameRef.current.scrollIntoView()
  }

  const onClickPOEditItem = (e) => {
    const itemIndex = parseInt(e.target.id)
    setCurrentItemIndex(itemIndex)
    setPOItemDetail(po.item_details[itemIndex])

    // Highlight the stock in item detail being edited
    highlightItemDetailsRow(itemIndex, true)

    // Disable the elipse button
    setEditMode(true)

    poItemDetailNameRef.current.focus()
    poItemDetailNameRef.current.scrollIntoView()
  }

  const onClickPODeleteItem = (e) => {
    const itemIndex = parseInt(e.target.id)
    setPO({ ...po, item_details: po.item_details.filter((item, index) => itemIndex !== index) })

    poItemDetailNameRef.current.focus()
    poItemDetailNameRef.current.scrollIntoView()
  }


  const onClickDDButton = (e) => {
    const dd_menu = e.target.closest('.dd-menu')
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })

    const action_btn_menu = dd_menu.querySelector('.action-btn-menu')
    action_btn_menu.classList.toggle('show-dd-menu')
  }

  const onDDFocus = (e) => {
    const index = parseInt(e.target.id)

    // Hide all previously oppened action buttons except the current active
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (i !== index) act_btn.classList.remove('show-dd-menu')
    })
  }

  const onFocusItemNameInput = (e) => {
    const action_btn_menu_all = document.querySelectorAll('.action-btn-menu')
    action_btn_menu_all.forEach((act_btn, i) => {
      if (act_btn.classList.contains('show-dd-menu')) act_btn.classList.remove('show-dd-menu')
    })
  }


  useEffect(() => {
    if (currentProductsList.length > 0)
      ReactDOM.render(
        <AutoCompleteList
          valueSetter={(value) => setPOItemDetail({ ...poItemDetail, name: value })}
          keyPressed={keyPressed}
          setItemClicked={setItemClicked}
          items={currentProductsList}
        />, document.getElementById('name-acl-container')
      )
    else
      ReactDOM.unmountComponentAtNode(document.getElementById('name-acl-container'))

    if (keyPressed === 'ArrowUp' || keyPressed === 'ArrowDown') setKeyPressed('')

    if (itemClicked) {
      setItemClicked(false)
      setCurrentProductsList([])
    }
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poItemDetail.name, keyPressed, itemClicked])

  useEffect(() => {
    // Check if the item_full_description is found
    const item = (
      productsList
      .find((product) => ( product.item_full_description.toLowerCase() === poItemDetail.name.toLowerCase()))
    )

    setCurrentItem(item)

    if (item) {
      setItemUnitDescriptionList(item.item_units.map(item => item.description))
      setPOItemDetail({
        ...poItemDetail,
        id: item.item_id,
        unit: (editMode) ? poItemDetail.unit : item.item_units.map(item => item.description)[0]
      })
    } else setItemUnitDescriptionList([])

    setEditMode(false)
    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poItemDetail.name])

  useEffect(() => {
    // Know the current item's unit fractional property if true
    if (currentItem) {
      if (currentItem.item_units.length > 0) {
        const fractional = currentItem.item_units.find(item => item.description === poItemDetail.unit).fractional
        setCurrentUnitIsFractional(fractional)
      }

      const current_unit = currentItem.item_units.find(item_unit => item_unit.description === poItemDetail.unit)
      setPOItemDetail({
        ...poItemDetail,
        fob: current_unit.capital_amount,
        total: (current_unit.capital_amount * poItemDetail.quantity)
      })
    }

    /* Hack to avoid the eslint warning */
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poItemDetail.unit, currentItem])

  useEffect(() => {
    setItemOK(currentItem && (poItemDetail.quantity > 0))
  }, [poItemDetail.quantity, currentItem])

  return (
    <React.Fragment>
      <div id='item-unit-quantity-container'>
        <table className="table-item-unit-details striped-table">
          <thead>
            <tr className='table-header'>
              <th>#</th>
              <th>Item</th>
              <th>Unit</th>
              <th style={{textAlign: 'center'}}>Quantity</th>
              <th>Remarks</th>
              <th>Action</th>
            </tr>
          </thead>
          {
            po.item_details.map((item, index) => (
              <tbody key={index}>
                <tr id={index+'item-details-row'}>
                  <td>{index + 1}</td>
                  <td>{item.name}</td>
                  <td>{item.unit}</td>
                  <td style={{textAlign: 'center'}}>{item.quantity}</td>
                  <td>{item.remarks}</td>
                  <th>
                    <div key={index} className='dd-menu'>
                      <button
                        id={index+'action-row-btn'}
                        onClick={onClickDDButton}
                        onFocus={onDDFocus}
                        disabled={editMode}
                        className={!editMode ? 'pospro-action-btn' : 'pospro-action-btn disabled-button'}>
                        <FontAwesomeIcon icon='ellipsis-v'/>
                      </button>
                      <div className='action-btn-menu'>
                        <button
                          id={index+'edit-row-btn'}
                          onClick={onClickPOEditItem}
                          className="pospro-action-btn edit-row-btn">
                          e
                        </button>
                        <button
                          id={index+'del-row-btn'}
                          onClick={onClickPODeleteItem}
                          className="pospro-action-btn del-row-btn">
                          &times;
                        </button>
                      </div>
                    </div>
                  </th>
                </tr>
              </tbody>
            ))
          }
          <thead>
            <tr>
              <th></th>
              <th>
                <div className='input-container'>
                  <input
                    ref={poItemDetailNameRef}
                    className={(currentItem || poItemDetail.name === '') ? '' : 'not-found'}
                    autoComplete='off'
                    placeholder='search in [brand] [name] [description]'
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    onFocus={onFocusItemNameInput}
                    value={poItemDetail.name}
                  />
                  <div id='name-acl-container' className='acl-container'></div>
                </div>
              </th>
              <th>
                <select
                  id="item-unit"
                  onChange={(e) => { setPOItemDetail({...poItemDetail, unit: e.target.value}) } }
                  value={poItemDetail.unit}>
                  {
                    itemUnitDescriptionList.map((unit, index) => (
                      <option key={index}>{unit}</option>
                      )
                    )
                  }
                </select>
              </th>
              <th>
                <input
                  style={{textAlign: 'center'}}
                  id='item-quantity'
                  type='number'
                  min='1'
                  onChange={(e) => setPOItemDetail({
                    ...poItemDetail,
                    quantity: (e.target.value)
                      ? currentUnitIsFractional
                          ? Math.abs(parseFloat(e.target.value))
                          : Math.abs(parseInt(e.target.value))
                      : ''
                  })}
                  value={poItemDetail.quantity}
                />
              </th>
              <th>
                <input
                  id='item-remarks'
                  onChange={(e) => setPOItemDetail({...poItemDetail, remarks: e.target.value})}
                  value={poItemDetail.remarks}
                />
              </th>
              <th>
                <button
                  id='po-add-item'
                  className={ itemOK ? 'pospro-action-btn' : 'pospro-action-btn disabled-button' }
                  disabled={!itemOK}
                  onClick={onClickPOAddItem}>
                  <FontAwesomeIcon icon='plus' />
                </button>
              </th>
            </tr>
          </thead>
        </table>
      </div>
      <POItemListStyle />
    </React.Fragment>
  )
}

function POInner() {
  return (
    <ContentInner>
      <div id='po-container'>
        <POForm />
        <POItemList />
      </div>
      <POInnerStyle />
    </ContentInner>
  )
}

export default React.memo(POInner)